import { h } from './dom.js'
import { state, loadPgnText, hasStamps } from '../lib/state.js'
import { on } from '../lib/bus.js'
import { SAMPLE_PGN } from '../config.js'
import { toast } from './toast.js'
import { confirmDialog } from './dialog.js'

export function mountPgnPanel(parent) {
  const textarea = h('textarea.pgn-input', {
    rows: 6,
    placeholder: '[Event "Club Championship"]\n\n1. e4 e5 2. Nf3 …',
    spellcheck: false,
  })
  const errorBox = h('div.form-error', { hidden: true })
  const fileInput = h('input', {
    type: 'file',
    accept: '.pgn,text/plain,application/x-chess-pgn',
    hidden: true,
    onChange: async (e) => {
      const file = e.target.files?.[0]
      if (!file) return
      textarea.value = await file.text()
      e.target.value = ''
      await load(textarea.value)
    },
  })

  async function load(raw) {
    if (hasStamps() && raw.trim() !== state.pgn.raw.trim()) {
      const ok = await confirmDialog({
        title: 'Replace game?',
        message: 'Loading a different PGN clears every timestamp you have set for the current game.',
        confirmLabel: 'Replace game',
        danger: true,
      })
      if (!ok) return
    }
    const parsed = loadPgnText(raw)
    if (parsed.error) {
      errorBox.textContent = parsed.error
      errorBox.hidden = false
    } else {
      errorBox.hidden = true
      const n = parsed.moves.length
      toast(`Loaded ${n} ${n === 1 ? 'move' : 'moves'} — tag each one to a video time`)
    }
  }

  const panel = h(
    'section.card',
    {},
    h('h2.card-title', {}, 'Game'),
    textarea,
    errorBox,
    h(
      'div.btn-row',
      {},
      h('button.btn.primary', { type: 'button', onClick: () => load(textarea.value) }, 'Load PGN'),
      h('button.btn', { type: 'button', onClick: () => fileInput.click() }, 'Upload .pgn'),
      h(
        'button.btn.ghost',
        {
          type: 'button',
          onClick: () => {
            textarea.value = SAMPLE_PGN
            load(SAMPLE_PGN)
          },
        },
        'Sample game',
      ),
    ),
    fileInput,
  )

  // Keep the textarea in sync when the project is restored or imported.
  on('pgn', () => {
    if (state.pgn.raw && textarea.value.trim() !== state.pgn.raw.trim()) {
      textarea.value = state.pgn.raw
    }
    if (!state.pgn.error) errorBox.hidden = true
  })

  parent.appendChild(panel)
  return panel
}
